
  const freeShippingThreshold = 500; // Example threshold for free shipping
  const progressBar = document.getElementById('progress-bar');
  const remainingAmount = document.getElementById('remaining-amount');

  // Function to update the progress bar
  function updateProgressBar(cartTotal) {
    const remaining = freeShippingThreshold - cartTotal;
    remainingAmount.textContent = remaining > 0 ? `₹${remaining.toFixed(2)}` : '₹0';

    const progress = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
    progressBar.style.width = `${progress}%`;
  }

  // Fetch cart total dynamically using Shopify's cart API
  function updateCart() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        updateProgressBar(cart.total_price / 100); // Divide by 100 to get actual price
      })
      .catch((error) => console.error('Error fetching cart:', error));
  }

  // Listen for cart updates (when items are added or removed)
  document.addEventListener('cart:updated', updateCart());






